import { Request,BaseApiUrl } from "./api";

// 列表
export const getHrPostListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/HrPost/get`, { params: params });
};


//新增
export const addHrPost = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrPost/Post`, params);
};

//编辑
export const editHrPost = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrPost/Put`, params);
};

//删除
export const removeHrPost = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrPost/Put`, params);
};
//批量删除
export const batchDeleteHrPost = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrPost/BatchDelete`, params);
};

// export const batchDeleteHrPost = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/HrPost/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
